/**
 * The different languages
 * The order defines the importance
 *
 * e.g., when looking into a French article (`fr`), the order of to be compared articles will be `['nl', 'de']`
 *
 * @type {[string,string,string]}
 */
export const LANGUAGES = ['nl', 'fr', 'de'];

/**
 * The different types of annotations
 * The order defines the sorting of the rendering of the annotations
 * The actual language-dependent labels should be adjusted in the folder `i18n`
 *
 * @type {[string,string,string,string,string,string]}
 */
export const ANNOTATION_TYPES = ['history', 'pref', 'arrest', 'comment', 'relevant', 'ref'];
/**
 * The annotation types of which the title should be viewable
 *
 * @type {[string,string]}
 */
export const ANNOTATION_HAVE_TITLE = ['pref', 'arrest'];

/**
 * The types that are searchable in the advanced searching form
 *
 * @type {[string,string,string]}
 */
export const SEARCH_TYPE_FILTERS = ['structure', 'pref', 'arrest'];



/** WEBPACK FOOTER **
 ** ./src/constants/dia.js
 **/